import { render } from "./updateprofile.vue?vue&type=template&id=f36e333a&scoped=true"
import script from "./updateprofile.vue?vue&type=script&lang=js"
export * from "./updateprofile.vue?vue&type=script&lang=js"

import "./updateprofile.vue?vue&type=style&index=0&id=f36e333a&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36e333a"]])

export default __exports__